import { render, staticRenderFns } from "./ModalPage.vue?vue&type=template&id=4238ce44&scoped=true&lang=pug&"
import script from "./ModalPage.vue?vue&type=script&lang=js&"
export * from "./ModalPage.vue?vue&type=script&lang=js&"
import style0 from "./ModalPage.vue?vue&type=style&index=0&id=4238ce44&lang=scss&scoped=true&"
import style1 from "./ModalPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4238ce44",
  null
  
)

export default component.exports